import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  audioFile: belongsTo('asset', { inverse: null }),
  audioplayer: belongsTo('audioplayer', { inverse: 'tracks' }),
});
